// Main
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE'
export const CLEAR_DATA = 'CLEAR_USER_DATA'
